//Inicializamos el websocket
let webSocket = null;
let puerto = "30001";
let protocolo = "wss";
let guid = null;
let error = 0;

//Esta función arranca la aplicación escritorio de telco.
function lanzarAplicacionFirma() {
  //Rango nosotros hemos metido 40000, Telco pone 30000
  puerto = Math.floor(Math.random() * 9999 + 40000);

  var socket = new WebSocket(protocolo + "://localhost:" + puerto + "/websocket/sign");

  socket.onerror = function (evt) {
    //Lanzamos la aplicación de escritorio de firma
    guid = create_UUID();

    window.location.assign("epad://" + puerto + "&" + guid);

    setTimeout(mostrarTexto, 2000);
  }

  socket.onopen = function (evt) {
    socket.close();
    lanzarAplicacionFirma();
  }



}

const create_UUID = function () {
  var dt = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return uuid;
}


const mostrarTexto = function () {
  if (webSocket == undefined || webSocket == null) {
    if ("WebSocket" in window) {

      webSocket = new WebSocket(protocolo + "://localhost:" + puerto + "/websocket/sign");

      webSocket.onmessage = function (evt) {
        var recibido = JSON.parse(evt.data);
        switch (recibido.codigo) {
          case "1":
            localStorage.setItem("firmaB64", recibido.imagenFirma);
            cerrarFirma();
            //recogerFirma(evt);
            break;
          case "2":
            cerrarFirma();
            break;
          case "4":
            localStorage.setItem("SignError", "Operación de firma cancelada");
            cerrarFirma();
            break;
          default:
            localStorage.setItem("SignError", "Se ha detectado un problema con el componente de firma por lo que deberá finalizar el contrato, firmándolo por otro medio.");
            cerrarFirma();
            break;
        }
      }

      webSocket.onopen = function (evt) {
        //Datos que se envia para sacar el texto y la firma
        //Si no se rellena la variable id y nombre no salta la firma
        var message = { codigo: "1" };
        message.nombre = "Nombre";
        message.id = "id";
        message.lenguaje = "es_ES";
        message.guid = guid;
        webSocket.send(JSON.stringify(message));
      }


      webSocket.onerror = function (evt) {
        if (error < 3) {
          error = error + 1;
          webSocket = null;
          setTimeout(mostrarTexto, 2000);
        } else {
          localStorage.setItem("SignError", "Se ha detectado un problema con el componente de firma por lo que deberá finalizar el contrato, firmándolo por otro medio.");
          cerrarFirma();
        }
      }
    }

  } else {
    cerrarFirma();
  }
}

const recogerFirma = function (event) {
  var canvasObj = document.getElementById('cnv');
  canvasObj.getContext('2d').clearRect(0, 0, canvasObj.width, canvasObj.height);
  sigRawDataObj.value = "Signature Raw Data: ";
  sigImageDataObj.value = "Signature Image Data: ";
  imgWidth = canvasObj.width;
  imgHeight = canvasObj.height;

  var obj = JSON.parse(event.data);
  var ctx = document.getElementById('cnv').getContext('2d');
  var firma = 'data:image/png;base64,' + obj.imagenFirma;
  if (obj.imagenFirma != '') {
    sigImageDataObj.value = obj.imagenFirma;
    var img = new Image();
    img.onload = function () {
      ctx.drawImage(img, 0, 0, imgWidth, imgHeight);
    }
    img.src = firma;
    signed = true;
    cerrarFirma();
  }
}


const cerrarFirma = function () {
  // Hay quen enviar un código 2 para cerrar la aplicación de escritorio de telco
  var message = { codigo: "2" };
  message.guid = guid;
  webSocket.send(JSON.stringify(message));
  webSocket = null;
}
